const t = (e) => ({
  contentWrapper: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end"
  },
  title: {
    color: e.palette.common.blue400
  },
  desc: {
    color: e.palette.common.grey200
  },
  btnsWrapper: {
    gap: 16
  }
}), o = t;
export {
  o as default
};
